import { render, staticRenderFns } from "./RegoCard.vue?vue&type=template&id=89e5ad6c&scoped=true&"
import script from "./RegoCard.vue?vue&type=script&lang=js&"
export * from "./RegoCard.vue?vue&type=script&lang=js&"
import style0 from "./RegoCard.vue?vue&type=style&index=0&id=89e5ad6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e5ad6c",
  null
  
)

export default component.exports